<app-modal-wrapper
  title="Select Port"
  [showFooter]="false"
  (closeRequest)="closeModal()"
>
  <div class="flex flex-col gap-5 h-[450px]">
    <div class="relative w-full group">
      <i class="pi pi-search absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
      <input
        pInputText
        type="text"
        [(ngModel)]="filter"
        (input)="handleSearch($any($event.target).value)"
        placeholder="Search by name or acronym..."
        class="w-full pl-6 pr-10 py-2 text-sm border-gray-200 rounded-lg bg-gray-50 focus:bg-white transition-colors"
      />
    </div>

    <app-table
      [data]="ports"
      [columns]="tableColumns"
      [actions]="tableActions"
      [totalRecords]="totalItems"
      [loading]="loading"
      [rows]="10"
      [scrollable]="true"
      [directAction]="true"
      (onLazyLoad)="loadLazy($event)">
    </app-table>
  </div>
</app-modal-wrapper>
